
import { defineComponent } from 'vue'
import { NText, NSpin } from 'naive-ui'
export default defineComponent({
  components: {
    NText,
    NSpin,
  },
})
